var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DateTime } from 'luxon';
import { ShortListDate } from './ShortListDate';
import styles from './dateTimePicker.module.scss';
import classNames from 'classnames';
import { Time } from 'src/ui/components/Input/DateTimeInput/components/Time/Time';
import { DateTabs } from 'src/ui/components/Input/DateTimeInput/components/DateTabs/DateTabs';
import { useState } from 'react';
import { DATE_TABS, DEFAULT_TIME_LABEL, E_DATE_TAB } from 'src/ui/components/Input/DateTimeInput/constants';
import { getNow } from 'src/shared/helpers/dateHelpers';
import { useUpdate } from 'src/shared/hooks/useLifecycle';
import { CalendarsWrapper } from 'src/ui/components/Input/DateTimeInput/components/CalendarsWrapper/CalendarsWrapper';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var DateTimePicker = function (props) {
    var i18n = props.i18n, startDate = props.startDate, endDate = props.endDate, shortcutDates = props.shortcutDates, currentShortcut = props.currentShortcut, className = props.className, onDateChange = props.onDateChange, onShortcutDateClick = props.onShortcutDateClick;
    var _a = useState(DATE_TABS[0]), currentTab = _a[0], setCurrentTab = _a[1];
    var timeLabel = getPropsByKeyPath(i18n === null || i18n === void 0 ? void 0 : i18n.components, 'dateTimeRangeSelectInput.customView.pickers.timeLabel') || DEFAULT_TIME_LABEL;
    useUpdate(function () {
        if (currentTab.type === E_DATE_TAB.FROM) {
            onDateChange({ startDate: null, endDate: getNow() });
        }
    }, [currentTab]);
    var handleDateChange = function (interval) {
        var _a, _b, _c;
        var startIsDate = interval.startDate instanceof DateTime;
        var endIsDate = interval.endDate instanceof DateTime;
        if (currentTab.type === E_DATE_TAB.FROM &&
            interval.startDate instanceof DateTime &&
            endDate instanceof DateTime &&
            interval.startDate.toMillis() > endDate.toMillis()) {
            // Don't set start date if it's after end date when we are in FROM tab
            return;
        }
        onDateChange({
            startDate: startIsDate
                ? interval.startDate.set({
                    hour: ((_a = interval.startDate) === null || _a === void 0 ? void 0 : _a.hour) || 0,
                    minute: ((_b = interval.startDate) === null || _b === void 0 ? void 0 : _b.minute) || 0,
                    second: ((_c = interval.startDate) === null || _c === void 0 ? void 0 : _c.second) || 0,
                })
                : null,
            endDate: currentTab.type === E_DATE_TAB.FROM ? getNow() : endIsDate ? interval.endDate : null, // always get now if we are in FROM tab
        });
    };
    var handleTimeChange = function (type, time) {
        var timeParam = { hour: time.hours, minute: time.minutes, second: 0 };
        switch (type) {
            case 'from': {
                var startDateWithTime = startDate === null || startDate === void 0 ? void 0 : startDate.set(timeParam);
                onDateChange({ startDate: startDateWithTime, endDate: endDate });
                break;
            }
            case 'to': {
                var endDateWithTime = endDate === null || endDate === void 0 ? void 0 : endDate.set(timeParam);
                onDateChange({ startDate: startDate, endDate: endDateWithTime });
                break;
            }
        }
    };
    var handleDatesShortcutChange = function (_a) {
        var shortcutDate = _a.shortcutDate, startDate = _a.startDate, endDate = _a.endDate;
        if (onDateChange) {
            onDateChange({ shortcutDate: shortcutDate, startDate: startDate, endDate: endDate });
        }
    };
    var endDateByTab = currentTab.type === E_DATE_TAB.FROM ? getNow() : endDate;
    return (_jsxs("div", __assign({ className: classNames(styles.dateTimePickerWrapper, className) }, { children: [_jsx(DateTabs, { dateTabs: DATE_TABS, currentTab: currentTab, onTabChange: setCurrentTab, i18n: i18n }), currentTab.type === E_DATE_TAB.SUGGESTION ? (_jsx(ShortListDate, { shortcutDates: shortcutDates, currentShortcut: currentShortcut, onShortcutDateClick: onShortcutDateClick, onDateChange: handleDatesShortcutChange, i18n: i18n })) : (_jsxs("div", __assign({ className: styles.calendarsWrapper }, { children: [_jsx(CalendarsWrapper, { startDate: startDate, endDate: endDateByTab, onDayClick: handleDateChange }), _jsx("span", { className: styles.separator }), _jsxs("div", __assign({ className: styles.timeWrapper }, { children: [_jsxs("div", __assign({ className: styles.time }, { children: [_jsx("p", { children: timeLabel }), _jsx(Time, { onTimeChange: function (time) { return handleTimeChange('from', time); }, hours: startDate === null || startDate === void 0 ? void 0 : startDate.hour, minutes: startDate === null || startDate === void 0 ? void 0 : startDate.minute })] })), _jsxs("div", __assign({ className: styles.time }, { children: [_jsx("p", { children: timeLabel }), _jsx(Time, { onTimeChange: function (time) { return handleTimeChange('to', time); }, hours: endDateByTab === null || endDateByTab === void 0 ? void 0 : endDateByTab.hour, minutes: endDateByTab === null || endDateByTab === void 0 ? void 0 : endDateByTab.minute })] }))] }))] })))] })));
};
